import Image from "next/image";
import React from "react";
import DataCenter from "../../public/images/invest/sets-cooling-towers-data-center-building.png";

const DigitalDivide = () => {
  return (
    <div className="my-40">
      <div className="flex gap-16">
        <div className="flex flex-col w-1/2 gap-10">
          <div className="text-lg font-bold">Crossing the digital divide</div>
          <div className="flex flex-col gap-2 text-5xl font-extrabold">
            <span>Listening to</span>
            <span>Mechanical</span>
            <span>Contractors</span>
          </div>
          <div className="font-semibold leading-loose">
            Order technology can be intimidating due to its perceived cost and
            complexity, but Easy Duct App makes it easy to get started. With
            free purchasing options and a user-friendly interface that mimics
            common cutsheets, you can experience the convenience of digital
            order technology without any of the hesitation!
          </div>
        </div>
        <div>
          <Image src={DataCenter.src} width={609} height={459} alt="" />
        </div>
      </div>
    </div>
  );
};

export default DigitalDivide;
